import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'

export default function Contact() {
    return (
        <div className="overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div id="title" className="relative">
                            <h2 className="font-display text-5xl font-medium sm:text-7xl text-black"><span className="relative whitespace-nowrap text-[#0077d3]"><svg aria-hidden="true" viewBox="0 0 418 42" className="absolute -mt-1 ml-1 top-3/5 left-0 h-[0.45em] w-full fill-blue-400 rotate-180" preserveAspectRatio="none"><path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z" /></svg><span className="relative text-black">Bize ulaşın</span></span></h2>
                        </div>
                        <p className="mt-6 text-lg leading-8 text-gray-600" data-aos="fade-right">
                            Bizimle iletişime geçmek için aşağıdaki formu doldurabilirsiniz. En kısa sürede sizinle iletişime geçeceğiz.
                        </p>
                        <div className="flex flex-col w-full p-4">
                            <div className='flex flex-row items-center space-x-0 lg:space-x-4 w-128'>
                                <div className="flex flex-col flex-grow">
                                    <label
                                        htmlFor="name"
                                        className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                                    >
                                        İsim
                                    </label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="isim soyisim"
                                        defaultValue=""
                                        className="text-sm sm:text-base w-full border rounded-xl placeholder-gray-400 focus:border-indigo-400 focus:outline-none"
                                    />
                                </div>
                                <div className="flex flex-col flex-grow">
                                    <label
                                        htmlFor="email"
                                        className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                                    >
                                        eposta adresi
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        placeholder="email"
                                        defaultValue=""
                                        className="text-sm sm:text-base w-full border rounded-xl placeholder-gray-400 focus:border-indigo-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4 mt-4">
                                <label
                                    htmlFor="message"
                                    className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                                >
                                    Mesajınız
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    type="text"
                                    placeholder="iletmek istediğiniz mesaj"
                                    defaultValue=""
                                    className="text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:border-indigo-400 focus:outline-none p-4"
                                />
                            </div>
                            <div className='flex flex-col justify-center'>
                                <button
                                    type="submit"
                                    className="bg-[#0077d3] hover:bg-[#0077d3]/90 duration-500 transition-all text-white text-sm sm:text-base font-semibold uppercase py-2 sm:py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full"
                                    style={{ transition: "all .15s ease" }}
                                >
                                    Gönder
                                </button>
                            </div>
                        </div>

                    </div>
                    <img
                        src="/icons/contact.svg"
                        alt="features image"
                        className="w-[48rem] max-w-none rounded-xl sm:w-[57rem] md:-ml-4 lg:-ml-0"
                        width={2432}
                        height={1442}
                        data-aos="fade-top"
                    />
                </div>
            </div>
        </div >
    )
}